import { Space } from 'antd';
import styled, { css } from 'styled-components';
import { Caption01 } from 'components/styles';

export const BaseStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const Container = styled.div`
  ${BaseStyles};
`;

export const ViewContainer = styled.div`
  ${BaseStyles};
  justify-content: flex-end;
`;

export const CountText = styled.span`
  ${Caption01};
  color: var(--gray-80);
`;

export const SelectWithLabel = styled(Space)`
  .ant-select-selection-item {
    font-weight: bold;
  }
  .ant-select-arrow {
    margin-top: -16px;
    color: var(--gray-70);
  }
`;
